import { LinearProgress, Typography } from "@material-ui/core";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { getModules } from "../../api/ModuleApi";
import { NewEntityId } from "../../data/constants";
import { ModuleIndex } from "../../model/Module";
import { routesPaths } from "../../Routes";
import { navigateTo } from "../../utils/Navigation";
import TranslatedMessage from "../translations/TranslatedMessage";
import ModuleGrid from "./ModuleGrid";

const ModuleList = () => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [modules, setModules] = React.useState<ModuleIndex[]>([]);
  const history = useHistory();

  React.useEffect(() => {
    getModules().then((result) => {
      setModules(result);
      setIsLoading(false);
    });
  }, []);

  if (isLoading) {
    return <LinearProgress variant="query" />;
  }

  return (
    <React.Fragment>
      <Typography variant="h5">
        <TranslatedMessage id="module.header" />
      </Typography>
      <ModuleGrid
        modules={modules}
        onRowClick={(row: ModuleIndex) => navigateTo(routesPaths.module(row.id), history)}
        onAddClick={() => history.push(routesPaths.module(NewEntityId))}
      />
    </React.Fragment>
  );
};

export default ModuleList;
